import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import renderUI from "./helper functions/api";

export const renderUserInterface = createAsyncThunk(
  "member/renderUI",
  renderUI
);

const alertInitialState = {
  actionDispatch: "",
  siteLogo: "",
  siteCopyright: "",
  siteColors: {
    primary: "",
    secondary: "",
  },
  emailLogo: "",
  emailPlatform: "",
};

export const renderUISlice = createSlice({
  name: "UI",
  initialState: alertInitialState,
  reducers: {
    setActionDispatch(state, { payload }) {
      state.actionDispatch = payload;
    },
  },

  extraReducers: {
    [renderUserInterface.fulfilled]: (_, { payload }) => {
      return payload;
    },
  },
});

export const { setActionDispatch } = renderUISlice.actions;
export default renderUISlice.reducer;
